module.exports = __webpack_public_path__ + "img/results-2.eb613812.png";